import {Action} from '@ngrx/store';
import {Deserialize, Serialize} from 'cerialize';
import {GetModuleSubscriptionsAction} from '../actions/module-subscriptions/get-module-subscriptions-action';
import {GetModuleSubscriptionsErrorAction} from '../actions/module-subscriptions/get-module-subscriptions-error-action';
import {GetModuleSubscriptionsSuccessAction} from '../actions/module-subscriptions/get-module-subscriptions-success-action';
import {ModuleSubscriptionsState} from '../states/module-subscriptions-state';

const initialState = new ModuleSubscriptionsState();

export function ModuleSubscriptionsReducer(serializedState: any = Serialize(initialState), action: Action): any {
  const state: ModuleSubscriptionsState = Deserialize(serializedState, ModuleSubscriptionsState);

  switch (action.type) {
    case GetModuleSubscriptionsAction.type:
      state.ready = false;
      state.error = null;
      break;

    case GetModuleSubscriptionsSuccessAction.type:
      state.ready = true;
      state.moduleSubscriptions = (<GetModuleSubscriptionsSuccessAction>action).moduleSubscriptions;
      state.error = null;
      break;

    case GetModuleSubscriptionsErrorAction.type:
      state.ready = true;
      state.moduleSubscriptions = null;
      state.error = (<GetModuleSubscriptionsErrorAction>action).error;
      break;

    default:
      return serializedState;
  }

  return Serialize(state);
}
